import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';
import { connect } from 'react-redux';
import useEmbedPdf from 'hooks/useEmbedPdf';
import { PAGES_ROOT } from 'config/api';
import dialogActions from 'core/dialogs/actions';
import Button from 'common/Button';
import Spinner from 'common/Spinner';

import dialogStyles from './styles/dialog';
import contentStyles from './styles/content';
import bodyStyles from './styles/body';
import footerStyles from './styles/footer';
import noticeStyles from './styles/notice';
import embedPdf from './styles/embedPdf';

const styles = (theme) => {
  const common = {
    body: bodyStyles(theme),
    content: contentStyles(theme),
    dialog: dialogStyles(theme),
    embedPdf: embedPdf(theme),
    footer: footerStyles(theme),
    notice: noticeStyles(theme),
  };
  return {
    ...common,
    content: {
      ...common.content,
      borderLeft: 'none',
      display: 'flex',
    },
    dialog: {
      ...common.dialog,
      height: '90%',
      maxWidth: '100%',
      width: '90%',

      [`@media(max-width: ${theme.screenSizes.mobileMax}px)`]: {
        height: '100%',
        width: '100%',
      },
    },
  };
};

export const EsignViewOnlyBare = ({
  classes,
  close,
  commonClasses,
  id,
  signModalCloseLabel,
  title,
}) => {
  useEmbedPdf(`${PAGES_ROOT}/esign/agreements/${id}`, '#embed-pdf', {
    pdfOpenParams: {
      view: 'FitH',
    },
    title,
  });

  const buttons = [
    {
      className: 'btn btn-mobile btn-i-accept',
      onClick: close,
      text: signModalCloseLabel,
      variant: 'primary',
    },
  ];
  return (
    <div className={classnames('modal-pdf', commonClasses, classes.dialog)}>
      <div className={classnames('modal-content', classes.content)}>
        <div className={classnames('modal-body', classes.body)} id="modal-body">
          <div>
            <div id="embed-pdf" className={classnames('embed-pdf', classes.embedPdf)} />
          </div>
        </div>
        <div className={classnames('modal-footer', classes.footer)}>
          {buttons.map((b, i) => (
            <Button
              /* eslint-disable-next-line react/no-array-index-key */
              key={`dialog-button-${i}`}
              className={classnames(`btn ${b.className} popbox-btn${i}`)}
              data-key={i}
              onClick={b.onClick}
              variant={b.variant}
            >
              {b.text}
              {b.className === 'btn btn-mobile btn-i-accept' && (
                <>
                  <i className="icon-arrow-thin-right" aria-hidden="true" />
                  <Spinner loading={false} />
                </>
              )}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

EsignViewOnlyBare.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  close: PropTypes.func.isRequired,
  commonClasses: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  signModalCloseLabel: PropTypes.string,
  title: PropTypes.string,
};

EsignViewOnlyBare.defaultProps = {
  signModalCloseLabel: 'Close',
  title: 'PDF Document',
};

const mapStateToProps = ({ dialogs }) => ({
  id: dialogs.params.id,
  signModalCloseLabel: dialogs.params.signModalCloseLabel,
  title: dialogs.params.label,
});

const EsignViewOnlyStyled = withStyles(styles)(EsignViewOnlyBare);

export default connect(mapStateToProps, { close: dialogActions.close })(EsignViewOnlyStyled);
